import React, { useEffect } from "react";
import Compressor from "compressorjs";
import { styled } from "@mui/material/styles";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import NativeSelect from "@mui/material/NativeSelect";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { allSlots } from "../../features/eventDetails/updateEventSlice";
import dayjs, { Dayjs } from "dayjs";
import {
  FormControl,
  Grid,
  Button,
  InputAdornment,
  Box,
  Typography,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers";
import OutlinedInput from "@mui/material/OutlinedInput";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import "./event.css";
import { useAppDispatch, useAppSelector } from "../../helpers/hooks";
import { fetchEventCategories } from "../../features/eventDetails/eventCategorySlice";
import { getAllDepartments } from "../../features/eventDetails/createEventSlice";
import Toaster from "../toaster";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import Loader from "../loader";

interface file {
  lastModified: number;
  lastModifiedDate: {};
  name: string;
  size: number;
  type: string;
}

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "visible",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const EventForm = ({
  open,
  handleClose,
  title,
  data,
  handleChange,
  submitForm,
  disablePublish,
  openToasterForm,
  isLoading,
}: any) => {
  const dispatch = useAppDispatch();
  const eventCategories = useAppSelector(
    (state) => state.eventCategories.eventCategories
  );
  const departments = useAppSelector((state) => state.createEvent.department);
  const getEvent = useAppSelector((state) => state.eventDetails.details.event);
  const location = ["Select Location", "Bengaluru", "Pune", "Virtual"];
  const [toastMessage, setToastMessage] = React.useState("");
  const [openToaster, setOpenToaster] = React.useState(false);
  const [imageName, setImageName] = React.useState<Array<file>>([]);
  const [idToDelete, setIdToDelete] = React.useState<any>([]);
  const options = [
    "Affordable And Clean Energy",
    "Clean Water And Sanitation",
    "Climate Action",
    "Decent Work And Economic Growth",
    "Gender Equality",
    "Good Health And Well-Being",
    "Industry Innovation And Infrastructure",
    "Life Below Water",
    "Life On Land",
    "No Poverty",
    "Partnerships For The Goals",
    "Peace And Justice String Institutions",
    "Quality Education",
    "Reduced Inequalities",
    "Responsible Consumption And Production",
    "Sustainable Cities And Communities",
    "Zero Hunger",
  ];

  const handleUploadClick = async (e: any) => {
    let images: Array<File> = e.target.files;
    let files = Array.from(images);

    const compressedFilesPromises = files.map((file) => compressImage(file));
    const compressedFiles: any = await Promise.all(compressedFilesPromises);
    handleFile(compressedFiles);
  };

  const compressImage = (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        width: 1024,
        height: 1024,
        convertTypes: ["image/jpeg"],
        success(result: any) {
          resolve(new File([result], file.name, { type: result.type }));
        },
        error(err) {},
      });
    });
  };

  const handleFile = (files: File[]) => {
    let newImageNames: any;
    if (files && files.length > 0) {
      handleChange((prevData: any) => ({
        ...prevData,
        imageName: files[0].name,
      }));
      newImageNames = files.filter((file) => {
        return !newImageNames?.some((f: any) => f.name === file.name);
      });
      setImageName((prevData: any) => [...prevData, ...newImageNames]);
    } else {
      setImageName((prevData: any) => [...prevData, ...files]);
    }
  };

  const changeDateFormat = (date: Dayjs | null) =>
    dayjs(date).format("YYYY-MM-DD");
  const changeTimeFormat = (time: Dayjs | null) =>
    dayjs(time).format("HH:mm:ss");

  const handleFormChange = (e: any, keyName?: string) => {
    let name = e.target ? e.target.name : keyName;
    let value: any = "";
    if (e.target) {
      if (e.target.name == "eventCategory") {
        value = { id: e.target.value };
      } else {
        value = e.target.value;
      }
      if (e.target.name == "allGoals") {
        handleChange((prevData: any) => ({
          ...prevData,
          [name]: typeof value === "string" ? value.split(",") : value,
        }));
        return;
      }
      if (title === "Update Event") {
        handleChange((prevData: any) => ({
          ...prevData,
          [name]: typeof value === "string" ? value.split(",") : value,
        }));
      }

      if (e.target.name == "allslots") {
        if (title == "Create Event") {
          handleChange((prevData: any) => ({
            ...prevData,
            ["totalSlots"]: e.target.value,
          }));
        }
        if (title == "Update Event") {
          let slotData = {
            id: data.id,
            allslots: e.target.value,
          };
          if (parseInt(e.target.value) > getEvent.allslots) {
            dispatch(allSlots(slotData)).then((res: any) => {
              if (res.meta.requestStatus == "fulfilled") {
                handleChange((prevData: any) => ({
                  ...prevData,
                  ["totalSlots"]: res?.payload?.availableslots,
                }));
              } else {
                setOpenToaster(true);
                setToastMessage(
                  "Give total slots should be greater than existing total slots."
                );
              }
            });
          } else {
            setOpenToaster(true);
            setToastMessage(
              "Give total slots should be greater than existing total slots."
            );
          }
        }
      }
    } else {
      value = e;
    }
    handleChange((prevData: any) => ({ ...prevData, [name]: value }));
  };

  const getImageName = (imageName: string) => {
    if (imageName?.includes("?")) {
      let name = imageName.split("?")[0].split("/");
      let img = name[name.length - 1];
      return img;
    } else return imageName;
  };
  const getIdByImage = (image: any) => {
    const event = data.eventImages.find(
      (event: any) => event.imageName === image
    );
    return event ? event.id : [];
  };
  const deleteImage = (e: any, imageToDelete: string) => {
    e.preventDefault();

    let imageArray = [...imageName];
    for (let i = 0; i < imageArray.length; i++) {
      if (imageArray[i].name === imageToDelete) {
        imageArray.splice(i, 1);
        break;
      }
    }
    if (title == "Update Event") {
      const id = getIdByImage(imageToDelete);
      idToDelete.push(id);
      setIdToDelete(idToDelete);
    }
    setImageName(imageArray);
  };

  useEffect(() => {
    dispatch(fetchEventCategories());
    dispatch(getAllDepartments());
  }, []);

  useEffect(() => {
    if (data.eventImages?.length) {
      const imageData = data.eventImages.map((item: any) =>
        Object.assign({}, item, { name: getImageName(item.imageName) })
      );
      setImageName(imageData);
    }
  }, [data.eventImages]);

  const handleQuillEdit = (value: any) => {
    handleChange((prev: any) => {
      return {
        ...prev,
        description: value,
      };
    });
  };
  const defaultQuillStyle = {
    height: "100px",
    width: "100%",
    backgroundSize: "auto 100%",
    backgroundRepeat: "no-repeat",
  };
  const emptyQuillStyle = {
    borderLeft: "1px solid red",
    borderRight: "1px solid red",
    borderBottom: "1px solid red",
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="lg"
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
          className="modal-title"
        >
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Box component="form" noValidate>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <FormControl variant="standard" fullWidth required>
                  <DemoItem label="Event Name">
                    <OutlinedInput
                      name="title"
                      placeholder="Event Name"
                      size="small"
                      value={data.title}
                      sx={
                        openToasterForm && data.title == ""
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(e) => handleFormChange(e)}
                    />
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Location">
                    <NativeSelect
                      id="demo-customized-select-native"
                      name="location"
                      placeholder="Select"
                      value={data.location}
                      sx={
                        openToasterForm &&
                        (data.location == "" ||
                          data.location == "Select Location")
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(e) => handleFormChange(e)}
                      input={<OutlinedInput />}
                      size="small"
                    >
                      {/* <option aria-label="None" value="" /> */}
                      {location.map((lc: string, index: number) => {
                        return (
                          <option key={index} value={lc}>
                            {lc}
                          </option>
                        );
                      })}
                    </NativeSelect>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth required>
                  <DemoItem label="Venue">
                    <OutlinedInput
                      name="venue"
                      value={data.venue}
                      sx={
                        openToasterForm && data.venue == ""
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      placeholder={
                        data.location == "Virtual"
                          ? "Meeting link"
                          : "Event Venue"
                      }
                      id="bootstrap-input"
                      size="small"
                      onChange={(e) => handleFormChange(e)}
                    />
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event Start Date">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name="eventStartDate"
                        format="DD/MM/YYYY"
                        disablePast
                        value={dayjs(data.eventStartDate)}
                        sx={
                          openToasterForm &&
                          data.eventStartDate.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeDateFormat(newValue),
                            "eventStartDate"
                          )
                        }
                        slotProps={{
                          textField: { size: "small", error: false },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event Start Time">
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="en"
                    >
                      <TimePicker
                        name="eventStartTime"
                        aria-placeholder="HH:MM AA"
                        value={dayjs(data.eventStartTime, "HH:mm:ss")}
                        sx={
                          openToasterForm &&
                          data.eventStartTime.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeTimeFormat(newValue),
                            "eventStartTime"
                          )
                        }
                        slotProps={{
                          textField: {
                            size: "small",
                            error: false,
                            inputProps: { ["placeholder"]: "anything" },
                          },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event End Date">
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="en-gb"
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        name="eventEndDate"
                        value={dayjs(data.eventEndDate)}
                        disablePast
                        sx={
                          openToasterForm &&
                          data.eventEndDate.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeDateFormat(newValue),
                            "eventEndDate"
                          )
                        }
                        slotProps={{
                          textField: {
                            size: "small",
                            error: false,
                            placeholder: "DD/MM/YYYY",
                          },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event End Time">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        name="eventEndTime"
                        value={dayjs(data.eventEndTime, "HH:mm:ss")}
                        sx={
                          openToasterForm &&
                          data.eventEndTime.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeTimeFormat(newValue),
                            "eventEndTime"
                          )
                        }
                        slotProps={{
                          textField: { size: "small", error: false },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Registration Start Date">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name="registrationStartDate"
                        format="DD/MM/YYYY"
                        value={dayjs(data.registrationStartDate)}
                        disablePast
                        sx={
                          openToasterForm &&
                          data.registrationStartDate.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeDateFormat(newValue),
                            "registrationStartDate"
                          )
                        }
                        slotProps={{
                          textField: { size: "small", error: false },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Registration Start Time">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        name="registrationStartTime"
                        value={dayjs(data.registrationStartTime, "HH:mm:ss")}
                        sx={
                          openToasterForm &&
                          data.registrationStartTime.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeTimeFormat(newValue),
                            "registrationStartTime"
                          )
                        }
                        slotProps={{
                          textField: { size: "small", error: false },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Registration End Date">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name="registrationEndDate"
                        format="DD/MM/YYYY"
                        value={dayjs(data.registrationEndDate)}
                        disablePast
                        sx={
                          openToasterForm &&
                          data.registrationEndDate.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeDateFormat(newValue),
                            "registrationEndDate"
                          )
                        }
                        slotProps={{
                          textField: { size: "small", error: false },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Registration End Time">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        name="registrationEndTime"
                        value={dayjs(data.registrationEndTime, "HH:mm:ss")}
                        sx={
                          openToasterForm &&
                          data.registrationEndTime.$d == "Invalid Date"
                            ? {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "red",
                                },
                              }
                            : {}
                        }
                        onChange={(newValue) =>
                          handleFormChange(
                            changeTimeFormat(newValue),
                            "registrationEndTime"
                          )
                        }
                        slotProps={{
                          textField: { size: "small", error: false },
                          popper: { style: { zIndex: 9999 } },
                        }}
                      />
                    </LocalizationProvider>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Department">
                    <NativeSelect
                      id="demo-customized-select-native"
                      name="dept"
                      value={data?.dept}
                      sx={
                        openToasterForm &&
                        (data.dept == "" || data.dept == undefined)
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      placeholder="Select Department"
                      onChange={(e) => handleFormChange(e)}
                      input={<OutlinedInput />}
                      size="small"
                    >
                      <option value="">Select Department</option>
                      {departments.length > 0 &&
                        departments.map((dep: any, index: number) => {
                          return (
                            <option key={index} value={dep}>
                              {dep}
                            </option>
                          );
                        })}
                    </NativeSelect>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event Category">
                    <NativeSelect
                      id="demo-customized-select-native"
                      name="eventCategory"
                      placeholder="Select Category"
                      value={
                        data?.eventCategory?.id ? data?.eventCategory?.id : ""
                      }
                      onChange={(e) => handleFormChange(e)}
                      input={<OutlinedInput />}
                      size="small"
                      sx={
                        openToasterForm && data?.eventCategory?.id == ""
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                    >
                      <option value="">Select Category</option>
                      {eventCategories.map((ec: any, index: number) => {
                        return (
                          <option key={index} value={ec.id}>
                            {ec.name}
                          </option>
                        );
                      })}
                    </NativeSelect>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Contact Person">
                    <OutlinedInput
                      name="contact"
                      placeholder="Email Address"
                      required
                      size="small"
                      value={data.contact}
                      sx={
                        openToasterForm && data.contact == ""
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(e) => handleFormChange(e)}
                    />
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Total Slots">
                    <OutlinedInput
                      name="allslots"
                      placeholder="No. of Slots"
                      id="bootstrap-input"
                      size="small"
                      value={data.allslots}
                      sx={
                        openToasterForm &&
                        (data.allslots == null || data.allslots == "")
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(e) => handleFormChange(e)}
                    />
                  </DemoItem>
                </FormControl>
              </Grid>
              {title == "Update Event" && (
                <Grid size={{ xs: 3 }}>
                  <FormControl variant="standard" fullWidth>
                    <DemoItem label="Slots Available">
                      <OutlinedInput
                        name="totalSlots"
                        disabled
                        placeholder="No. of Slots"
                        id="bootstrap-input"
                        size="small"
                        value={data.totalSlots}
                        onChange={(e) => handleFormChange(e)}
                      />
                    </DemoItem>
                  </FormControl>
                </Grid>
              )}
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event Goals">
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      name="allGoals"
                      value={data.allGoals ?? []}
                      onChange={(e) => handleFormChange(e)}
                      input={<OutlinedInput label="Event Goals" />}
                      renderValue={(selected) =>
                        selected.length === 0
                          ? "Select goals"
                          : selected.join(", ")
                      }
                      displayEmpty
                      MenuProps={{
                        disablePortal: true,
                      }}
                      size="small"
                      sx={
                        openToasterForm &&
                        (data.allGoals == null || data.allGoals.length === 0)
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                    >
                      <MenuItem disabled value="">
                        <em>Select goals</em>
                      </MenuItem>
                      {options.map((name) => (
                        <MenuItem key={name} value={name}>
                          <ListItemText primary={name} />
                          <Checkbox checked={data?.allGoals?.includes(name)} />
                        </MenuItem>
                      ))}
                    </Select>
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }}></Grid>
              <Grid size={{ xs: 9 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Description">
                    <ReactQuill
                      value={data.description}
                      onChange={handleQuillEdit}
                      placeholder="Event Description"
                      style={
                        openToasterForm &&
                        data.description.replace(/<(.|\n)*?>/g, "").trim()
                          .length === 0
                          ? emptyQuillStyle
                          : defaultQuillStyle
                      }
                      modules={{
                        toolbar: {
                          container: [
                            ["bold", "italic", "underline", "strike"],

                            [
                              {
                                list: "ordered",
                              },
                              {
                                list: "bullet",
                              },
                            ],

                            [{ align: [] }],

                            ["clean"],

                            [{ color: [] }, { background: [] }],
                          ],
                        },
                      }}
                    />
                  </DemoItem>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 3 }} direction="column">
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Event Banners:">
                    <Typography variant="caption" fontSize="11px">
                      Max. 5 Banners
                    </Typography>
                    <Button
                      component="label"
                      role={undefined}
                      disabled={imageName.length >= 5}
                      variant="outlined"
                      tabIndex={-1}
                      sx={{ textTransform: "capitalize" }}
                      className="image-upload-button"
                    >
                      Upload Photo
                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        multiple={true}
                        onChange={(e: any) => handleUploadClick(e)}
                      />
                    </Button>
                  </DemoItem>
                </FormControl>
                {imageName.length > 0 && (
                  <Box
                    sx={{
                      display: "grid",
                      marginTop: "10px",
                    }}
                    gap={1}
                  >
                    {imageName.map((image: any, index: number) => {
                      return (
                        <OutlinedInput
                          key={index}
                          size="small"
                          value={image.name}
                          className="image-name-style"
                          sx={{ color: "primary" }}
                          endAdornment={
                            <InputAdornment position="end">
                              <DeleteOutlinedIcon
                                fontSize="small"
                                color="primary"
                                sx={{ cursor: "pointer" }}
                                onClick={(e) => deleteImage(e, image.name)}
                              />
                            </InputAdornment>
                          }
                        />
                      );
                    })}
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ alignSelf: "center" }}>
          <Button
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            onClick={(e) => submitForm(e, data, imageName, idToDelete)}
            className="mui-modal-button"
            disabled={disablePublish}
          >
            Publish
          </Button>
        </DialogActions>
      </BootstrapDialog>
      {isLoading && (
        <div
          style={{
            position: "absolute", // Absolutely position the loader over the form
            top: "0%",
            left: "0%",
            bottom: "0%",
            width: "100%",
            height: "200%",
            backgroundColor: "rgba(0, 0, 0, 0.7)", // Semi-transparent overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px", // Match the form's border radius
            zIndex: "10000000", // Ensure the loader is on top
          }}
        >
          {/* ClipLoader spinner */}
          <Loader />
        </div>
      )}
      <Toaster
        openToaster={openToaster}
        toastMessage={toastMessage}
        handleToasterClose={() => setOpenToaster(false)}
      />
    </>
  );
};

export default EventForm;
